import React, { Fragment } from 'react';
import T from 'prop-types';

import Tooltip from '../../../../Tooltip';

const VISIBLE_ITEMS_COUNT = 3;

const joinNodes = (nodes) =>
  nodes.map((node, i) => (
    <Fragment key={i}>
      {i > 0 && ', '}
      {node}
    </Fragment>
  ));

const TruncatedItems = ({ items }) => {
  if (!items.length) return '-';

  const visible = items.slice(0, VISIBLE_ITEMS_COUNT);
  const overflow = items.slice(VISIBLE_ITEMS_COUNT);

  if (!overflow.length) return joinNodes(visible);

  return (
    <>
      {joinNodes(visible)}
      {', '}
      <Tooltip
        content={joinNodes(overflow)}
        colorVariant="light"
        overlayClassName="truncated-items-tooltip"
      >
        <span className="schedule-export-modal__more-link">+{overflow.length} More</span>
      </Tooltip>
    </>
  );
};

TruncatedItems.propTypes = {
  items: T.array.isRequired,
};

export default TruncatedItems;
